import { render } from "./FrisbuyGalleryScrollbar.vue?vue&type=template&id=3bfd652d&scoped=true"
import script from "./FrisbuyGalleryScrollbar.vue?vue&type=script&lang=js"
export * from "./FrisbuyGalleryScrollbar.vue?vue&type=script&lang=js"

import "./FrisbuyGalleryScrollbar.vue?vue&type=style&index=0&id=3bfd652d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bfd652d"]])

export default __exports__